module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-chara02-6dc2e1cbd69f49ebcb59471a1cb84cb7.png";